import { createFrontendModule } from '@backstage/frontend-plugin-api';
import devToolsPlugin from '@backstage/plugin-devtools/alpha';
import { RiToolsFill } from '@remixicon/react';

/** Replaces the default DevTools page with the internal landing page. */
const devToolsPageOverride = devToolsPlugin
  .getExtension('page:devtools')
  .override({
    params: {
      icon: <RiToolsFill />,
    },
  });

/** Bundles all DevTools overrides into a single frontend module. */
export const devToolsPluginOverride = createFrontendModule({
  pluginId: 'devtools',
  extensions: [devToolsPageOverride],
});
